import React from 'react'
import CentaCandidateReport from './centaCandidateReport'
import { useParams } from '@pankod/refine-react-router-v6'

const Ams_View_Report = () => {
  let { id } = useParams()
  return (
    <div>
     {id&&<CentaCandidateReport candidate={id} />} 
    </div>
  )
}

export default Ams_View_Report
